import React, { useState, useRef } from 'react';
import { usePartnerContext } from '../components/Context/PartnerContext';
import { useSnackbar } from './SnackBar';
import { Tabs, Tab, Box, Typography, Button, } from '@mui/material';
import { useProgressBar } from './ProgressBar';
import countriesData from '../countries.json';
import CommonCurrency from '../CommonCurrency.json';
import BankNames from '../BankNames.json';
import { IconButton, List, ListItem, ListItemText } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import {
    Grid, Stack, FormControl, InputLabel,
    Select, MenuItem, OutlinedInput, Checkbox, DialogContentText, Dialog,
    DialogTitle, DialogContent, DialogActions
} from '@mui/material';

// TabPanel component to manage tab content
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

const NewPartnerViews = () => {

    const [formData, setFormData] = useState({
        vatNumber: "",
        bankName: "",
        accountNumber: "",
        ibanNumber: "",
        accountHolderName: "",
        documentName: "",
        partnerClass: "",
        currency: "",
        partnerName: "",
        location: "",
        conatactnumber: "",
        email: "",
        contactperson: "",
        companyRegistration: "",
        companyNameEnglish: "",
        companyNameArabic: "",
        companyShortName: "",
        website: "",
        activationLink: ""

    });
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const handleCopy = () => {

        showSnackbar("copied to clipboard", "success");
        navigator.clipboard.writeText(partners.activationLink);
    };
    // Handle input changes to retain data when switching tabs
    const handleInputChange = (e, field) => {
        const value = e.target.value;
        setFormData((prevData) => ({
            ...prevData,
            [field]: value,
        }));
    };

    const { showSnackbar } = useSnackbar();
    const { partners, AddPartners, checkEmailExistance, checkPhoneExistance } = usePartnerContext();
    const { showProgress } = useProgressBar();
    const vatNumberRef = useRef(null);
    const bankNameRef = useRef(null);
    const accountNumberRef = useRef(null);
    const ibanNumberRef = useRef();
    const accountHolderNameRef = useRef();
    const documentNameRef = useRef();
    const partnerClassRef = useRef();
    const currencyRef = useRef(null);
    const partnerNameRef = useRef('');
    const conatactnumberRef = useRef('');
    const emailRef = useRef('');
    const contactpersonRef = useRef('');
    const companyRegistrationRef = useRef(null);
    const companyNameEnglishRef = useRef(null);
    const companyNameArabicRef = useRef(null);
    const companyShortNameRef = useRef(null);
    const websiteRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [emailExists, setEmailExists] = useState(null);
    const [phoneExists, setPhoneExists] = useState(null);
    const [emailformat, setemailformat] = useState(false);
    const [phonenumberformat, setphoneformat] = useState(false);
    const partnerIDref = useRef(200);
    const streetRef = useRef('');
    const buildingNoRef = useRef('');
    const neighborhoodRef = useRef('');
    const cityRef = useRef('');
    const stateRef = useRef('');
    const zipcodeRef = useRef('');
    const countryRef = useRef('');
    const [selectedCountry, setSelectedCountry] = useState('');
    const offlineServiceAvailableRef = useRef(false);
    const checkEmail = async () => {
        if (emailRef.current.value != "") {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (emailRegex.test(emailRef.current.value)) {
                setemailformat(false)
            } else {
                setemailformat(true)
            }
            const resp = await checkEmailExistance(emailRef.current.value);
            setEmailExists(resp)
        }
    };
    const [phoneNumber, setPhoneNumber] = useState('');
    const [isValid, setIsValid] = useState(null);
    const checkPhoneNumber = async () => {
        const number = conatactnumberRef.current.value.trim();
        const phoneregExp = /^\u002B966\d{9}$/;
        if (number !== "") {
            if (phoneregExp.test(number)) {
                setIsValid(true);
            } else {
                setIsValid(false);
            }
            const resp = await checkPhoneExistance(conatactnumberRef.current.value);
            setPhoneExists(resp);
        }
    }
    const formRefs = useRef([]);
    const handleClick = () => {
        formRefs.current.forEach(form => {
            const formElements = form.elements;
            for (let element of formElements) {
                if ((element.tagName === 'INPUT' && element.type !== 'submit') || element.tagName === 'SELECT') {
                    if (element.value === '') {
                        element.style.borderColor = 'red';
                    } else {
                        element.style.borderColor = '';
                    }
                }
            }
        });
    };
    const checkEmptyField = (e) => {
        if (e.target.value === "") {
            e.target.style.borderColor = '';
        } else {
            e.target.style.borderColor = '';
        }
    };

    const handleAddPartner = async () => {

        if (partnerNameRef.current.value.trim() === '' || streetRef.current.value.trim() === '' ||
            buildingNoRef.current.value.trim() === '' || neighborhoodRef.current.value.trim() === '' ||
            cityRef.current.value.trim() === '' || stateRef.current.value.trim() === '' ||
            zipcodeRef.current.value.trim() === '' || countryRef.current.value.trim() === '' ||
            conatactnumberRef.current.value.trim() === '' || emailRef.current.value.trim() === '' ||
            contactpersonRef.current.value === '' || formData.vatNumber.trim() === '' ||
            formData.bankName.trim() === '' || formData.accountNumber.trim() === '' ||
            formData.ibanNumber.trim() === '' || formData.accountHolderName.trim() === '' ||
            formData.documentName.trim() === '' || partnerClassRef.current.value.trim() === '' ||
            formData.currency.trim() === '' || formData.companyRegistration.trim() === '' ||
            formData.companyNameEnglish.trim() === '' || formData.companyNameArabic.trim() === '' ||
            formData.companyShortName.trim() === '' || formData.website.trim() === '' || selectedFile == null || files == null) {
            showSnackbar('Partner fields cannot be blank', 'error');
            handleClick();
            return;
        } else if (emailExists === true) {

            showSnackbar('email already exist', 'error');
            handleClick();
        } else if (phoneExists === true) {

            showSnackbar('Phone number already exist', 'error');
            handleClick();
        } else {
            showProgress(true);
            const p = await AddPartners({
                partnerID: 0, partnerName: partnerNameRef.current.value.trim(),
                contactNumber: conatactnumberRef.current.value
                , email: emailRef.current.value, contactPerson: contactpersonRef.current.value
                , vatNumber: formData.vatNumber, bankName: formData.bankName
                , accountNumber: formData.accountNumber, iban: formData.ibanNumber
                , accountHolderFullName: formData.accountHolderName
                , currency: formData.currency, crNumber: formData.companyRegistration,
                companyName: formData.companyNameEnglish, companyNameAR: formData.companyNameArabic,
                companyShortName: formData.companyShortName, website: formData.website, attachmentName: formData.documentName, partnerClass: partnerClassRef.current.value,
                streetName: streetRef.current.value.trim(),
                buildingNumber: buildingNoRef.current.value.trim(),
                neighborhood: neighborhoodRef.current.value.trim(),
                city: cityRef.current.value.trim(),
                state: stateRef.current.value.trim(),
                zipCode: zipcodeRef.current.value.trim(),
                country: countryRef.current.value.trim(),
                attachment: "",
                offlineServiceAvailable: offlineServiceAvailableRef.current?.checked || false,
            }, selectedFile, files);

            setFormData(partners);
            showProgress(false);
            showSnackbar('Partner added successfully', 'success');
            setTimeout(() => {
                navigate(`/editpartner/${p.id}/false`);
            }, 2000);
        }
    };



    const [bottomTabIndex, setBottomValue] = React.useState('1');
    const [topTabIndex, setTopValue] = React.useState('1');


    const [files, setFiles] = React.useState([]);

    const handlePartnerFileChange = (event) => {
        const newFiles = Array.from(event.target.files);
        setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    };

    const handleRemoveFile = (index) => {
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };
    const handleFileChange = (event) => {
        debugger;
        setSelectedFile(event.target.files[0]); // Get the first selected file
    };


    const [confirmStatusOpen, setConfirmStatusOpen] = useState(false);
    const [previousValue, setPreviousValue] = useState(false);
    const handleActive = () => {
        if (offlineServiceAvailableRef.current) {
            const current = offlineServiceAvailableRef.current.checked;
            // Save previous value before showing dialog
            setPreviousValue(!current); // Store old state
            setConfirmStatusOpen(true); // Open dialog
        }
    };
    const handleConfirmStatusChange = () => {
        const isChecked = offlineServiceAvailableRef.current?.checked || false;
        // Perform your update logic here (API call, state update, etc.)
        console.log('Status changed to:', isChecked ? 'Enabled' : 'Disabled');

        setConfirmStatusOpen(false);
    };
    const handleStatusDialogClose = () => {

        if (offlineServiceAvailableRef.current) {
            offlineServiceAvailableRef.current.checked = previousValue;
        }
        setConfirmStatusOpen(false); // Close the dialog
    };
    return (
        <div>
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>Partner</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="/admin">Home</a></li>
                            <li className="breadcrumb-item"><a href='/partner'>Partner</a></li>
                            <li className="breadcrumb-item active"><a href=''>Add Partner</a></li>
                        </ol>
                    </nav>
                </div>
                <section className="section">
                    <div className="row">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <nav className="navbar navbar-expand-lg navbar-light">
                                        <div className="container-fluid">

                                            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                                <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                                                    <li className="nav-item">
                                                        <a className="nav-link active" aria-current="page" href="#"></a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a className="nav-link" href="#"></a>
                                                    </li>

                                                </ul>
                                                <Button className="right-button"
                                                    variant="contained"
                                                    color="primary"
                                                    style={{
                                                        backgroundColor: '#02176D', color: 'white',
                                                    }}
                                                    onClick={handleAddPartner} >
                                                    Save
                                                </Button>
                                            </div>
                                        </div>
                                    </nav>
                                    {/*<div className="col-lg-8">*/}

                                    {/*    <div className="card-body">*/}
                                    {/*        <h5 className="card-title"></h5>*/}

                                    {/*        <form>*/}
                                    {/*            <div className="row mb-3">*/}
                                    {/*                <label htmlFor="inputText" className="col-sm-4 col-form-label" >Name</label>*/}
                                    {/*                <div className="col-sm-6">*/}
                                    {/*                    <input type="text" className="form-control" placeholder="Partner Name" ref={partnerNameRef}></input>*/}
                                    {/*                </div>*/}
                                    {/*            </div>*/}
                                    {/*            <div className="row mb-3">*/}
                                    {/*                <label htmlFor="inputPassword" className="col-sm-4 col-form-label">Location</label>*/}
                                    {/*                <div className="col-sm-6">*/}
                                    {/*                    <input className="form-control" placeholder="Location" ref={locationRef}></input>*/}
                                    {/*                </div>*/}
                                    {/*            </div>*/}
                                    {/*            <div className="row mb-3">*/}
                                    {/*                <label htmlFor="phone" className="col-sm-4 col-form-label">Phone number:</label>*/}
                                    {/*                <div className="col-sm-6">*/}
                                    {/*                    <input type="tel" id="phone" name="phone" className="form-control" placeholder="Location" required ref={conatactnumberRef}></input>*/}
                                    {/* {phonenumberformat == true && (<div className="form-text text-danger">{phonenumberformat == true ? "Invalid phone number. Please check the format." : ""}</div>)}*/}
                                    {/*                </div>*/}
                                    {/*            </div>*/}
                                    {/*            <div className="row mb-3">*/}
                                    {/*                <label htmlFor="inputEmail" className="col-sm-4 col-form-label">Email</label>*/}
                                    {/*                <div className="col-sm-6">*/}
                                    {/*                    <input type="email" className="form-control" placeholder="Email" ref={emailRef} onBlur={checkEmail} helperText="Please enter your name"></input>*/}
                                    {/*                    */}{/* Conditional rendering for email existence message */}


                                    {/*                    )}{emailformat == true && (<div className="form-text text-danger">{emailformat == true ? "The email format is incorrect. Please check." : ""}</div>)}*/}
                                    {/*                </div>*/}

                                    {/*            </div>*/}
                                    {/*            <div className="row mb-3">*/}
                                    {/*                <label htmlFor="inputPassword" className="col-sm-4 col-form-label">Conatact Person Name</label>*/}
                                    {/*                <div className="col-sm-6">*/}

                                    {/*                    <input type="text" id="contactname" name="contactname" className="form-control" placeholder="Conatact Person Name" required ref={contactpersonRef}></input>*/}
                                    {/*                </div>*/}
                                    {/*            </div>*/}
                                    {/*            <div>*/}
                                    {/*                <label ></label>*/}
                                    {/*                <div className="col-sm-6">*/}
                                    {/*                    <div className="form-check form-switch">*/}

                                    {/*                    </div>*/}
                                    {/*                </div>*/}
                                    {/*            </div>*/}

                                    {/*            <div>*/}
                                    {/*                <Box sx={{ width: '100%' }}>*/}
                                    {/*                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>*/}
                                    {/*                        <Tabs onChange={handleBottomTabChange} aria-label="basic tabs example">*/}
                                    {/*                            <Tab label="Finance Details" {...a11yProps(0)} />*/}
                                    {/*                            <Tab label="Documents" {...a11yProps(1)} />*/}
                                    {/*                            <Tab label="Company Details" {...a11yProps(2)} />*/}
                                    {/*                        </Tabs>*/}
                                    {/*                    </Box>*/}
                                    {/*                    <TabPanel value={bottomTabIndex} index={0}>*/}

                                    {/*                        <form>*/}
                                    {/*                            <div className="container">*/}
                                    {/*                                <div className="row mb-3">*/}
                                    {/*                                    <div className="col-sm-4">*/}
                                    {/*                                        <label htmlFor="Number" className="col-form-label">VAT Number</label>*/}
                                    {/*                                        <input type="text" ref={vatNumberRef} className="form-control" placeholder="VAT Number" value={formData.vatNumber}*/}
                                    {/*                                            onChange={(e) => handleInputChange(e, "vatNumber")} />*/}
                                    {/*                                    </div>*/}

                                    {/*                                    <div className="row mb-3">*/}
                                    {/*                                <label htmlFor="registrationNumber" className="col-sm-4 col-form-label">Company Registration Number</label>*/}
                                    {/*                                <div className="col-sm-6">*/}
                                    {/*                                    <input*/}
                                    {/*                                        type="text"value={formData.companyRegistration}*/}
                                    {/*                                        onChange={(e) => handleInputChange(e, "companyRegistration")}*/}
                                    {/*                                        id="registrationNumber"*/}
                                    {/*                                        className="form-control"*/}
                                    {/*                                        placeholder="Company Registration Number"*/}
                                    {/*                                        ref={companyRegistrationRef}*/}
                                    {/*                                    />*/}
                                    {/*                                </div>*/}
                                    {/*                            </div>*/}
                                    {/*                                    <div className="col-sm-4">*/}
                                    {/*                                        <label htmlFor="Name" className="col-form-label">Bank Name</label>*/}
                                    {/*                                        <input type="text" ref={bankNameRef} className="form-control" placeholder="Bank Name"value={formData.bankName}*/}
                                    {/*                                        onChange={(e) => handleInputChange(e, "bankName")} />*/}
                                    {/*                                    </div>*/}
                                    {/*                                    <div className="col-sm-4">*/}
                                    {/*                                        <label htmlFor="icon" className="col-form-label">Account Number</label>*/}
                                    {/*                                        <input type="text" ref={accountNumberRef} className="form-control" placeholder="Account Number"value={formData.accountNumber}*/}
                                    {/*                                        onChange={(e) => handleInputChange(e, "accountNumber")} />*/}
                                    {/*                                    </div>*/}
                                    {/*                                </div>*/}

                                    {/*                                <div className="row mb-3">*/}
                                    {/*                                    <div className="col-sm-4">*/}
                                    {/*                                        <label htmlFor="icon" className="col-form-label">IBAN Number</label>*/}
                                    {/*                                        <input type="text" ref={ibanNumberRef} className="form-control" placeholder="IBAN Number" value={formData.ibanNumber}*/}
                                    {/*                                        onChange={(e) => handleInputChange(e, "ibanNumber")}/>*/}
                                    {/*                                    </div>*/}
                                    {/*                                    <div className="col-sm-4">*/}
                                    {/*                                        <label htmlFor="icon" className="col-form-label">Account Holder Name</label>*/}
                                    {/*                                        <input type="text" ref={accountHolderNameRef} className="form-control" placeholder="Account Holder Name"value={formData.accountHolderName}*/}
                                    {/*                                        onChange={(e) => handleInputChange(e, "accountHolderName")} />*/}
                                    {/*                                    </div>*/}
                                    {/*                                    <div className="col-sm-4">*/}
                                    {/*                                        <label htmlFor="icon" className="col-form-label">Currency</label>*/}
                                    {/*                                        <input type="text" ref={currencyRef} className="form-control" placeholder="Currency"value={formData.currency}*/}
                                    {/*                                        onChange={(e) => handleInputChange(e, "currency")} />*/}
                                    {/*                                    </div>*/}
                                    {/*                                </div>*/}

                                    {/*                                <div className="row mb-3">*/}
                                    {/*                                    <div className="col-sm-4">*/}
                                    {/*                                        <label htmlFor="icon" className="col-form-label">Document Name</label>*/}
                                    {/*                                        <input type="text" ref={documentNameRef} className="form-control" placeholder="Document Name" value={formData.documentName}*/}
                                    {/*                                        onChange={(e) => handleInputChange(e, "documentName")}/>*/}
                                    {/*                                    </div>*/}
                                    {/*                                    <div className="col-sm-4">*/}
                                    {/*                                        <label htmlFor="inputNumber" className="col-form-label">Attachment</label>*/}
                                    {/*                                        <input className="form-control" type="file" id="formFile" onChange={handleFileChange} />*/}
                                    {/*                                    </div>*/}
                                    {/*                                    <div className="col-sm-4">*/}
                                    {/*                                        <label htmlFor="icon" className="col-form-label">Partner Class</label>*/}
                                    {/*                                        <input type="text" ref={partnerClassRef} className="form-control" placeholder="Partner Class" value={formData.partnerClass}*/}
                                    {/*                                        onChange={(e) => handleInputChange(e, "partnerClass")}/>*/}
                                    {/*                                    </div>*/}
                                    {/*                                </div>*/}
                                    {/*                            </div>*/}
                                    {/*                        </form>*/}
                                    {/*                    </TabPanel>*/}

                                    {/*                    <TabPanel value={bottomTabIndex} index={2}>*/}
                                    {/*                        <form>*/}
                                    {/*                            */}{/* Company Registration Number */}
                                    {/*                            <div className="row mb-3">*/}
                                    {/*                                <label htmlFor="registrationNumber" className="col-sm-4 col-form-label">Company Registration Number</label>*/}
                                    {/*                                <div className="col-sm-6">*/}
                                    {/*                                    <input*/}
                                    {/*                                        type="text"value={formData.companyRegistration}*/}
                                    {/*                                        onChange={(e) => handleInputChange(e, "companyRegistration")}*/}
                                    {/*                                        id="registrationNumber"*/}
                                    {/*                                        className="form-control"*/}
                                    {/*                                        placeholder="Company Registration Number"*/}
                                    {/*                                        ref={companyRegistrationRef}*/}
                                    {/*                                    />*/}
                                    {/*                                </div>*/}
                                    {/*                            </div>*/}

                                    {/*                            */}{/* Company Name (English) */}
                                    {/*                            */}{/* <div className="row mb-3">*/}{/*
                                    */}{/*                                <label htmlFor="companyNameEnglish" className="col-sm-4 col-form-label">Company Name (English)</label>*/}{/*
                                    */}{/*                                <div className="col-sm-6">*/}{/*
                                    */}{/*                                    <input*/}{/*
                                    */}{/*                                    value={formData.companyNameEnglish}*/}{/*
                                    */}{/*                                    onChange={(e) => handleInputChange(e, "companyNameEnglish")}*/}{/*
                                    */}{/*                                        type="text"*/}{/*
                                    */}{/*                                        id="companyNameEnglish"*/}{/*
                                    */}{/*                                        className="form-control"*/}{/*
                                    */}{/*                                        placeholder="Company Name (English)"*/}{/*
                                    */}{/*                                        ref={companyNameEnglishRef}*/}{/*
                                    */}{/*                                    />*/}{/*
                                    */}{/*                                </div>*/}{/*
                                    */}{/*                            </div> */}

                                    {/*                            */}{/* Company Name (Arabic) */}
                                    {/*                            <div className="row mb-3">*/}
                                    {/*                                <label htmlFor="companyNameArabic" className="col-sm-4 col-form-label">Company Name (Arabic)</label>*/}
                                    {/*                                <div className="col-sm-6">*/}
                                    {/*                                    <input*/}
                                    {/*                                    value={formData.companyNameArabic}*/}
                                    {/*                                    onChange={(e) => handleInputChange(e, "companyNameArabic")}*/}
                                    {/*                                        type="text"*/}
                                    {/*                                        id="companyNameArabic"*/}
                                    {/*                                        className="form-control"*/}
                                    {/*                                        placeholder="Company Name (Arabic)"*/}
                                    {/*                                        ref={companyNameArabicRef}*/}
                                    {/*                                    />*/}
                                    {/*                                </div>*/}
                                    {/*                            </div>*/}

                                    {/*                            */}{/* Company Short Name */}
                                    {/*                            <div className="row mb-3">*/}
                                    {/*                                <label htmlFor="companyShortName" className="col-sm-4 col-form-label">Company Short Name</label>*/}
                                    {/*                                <div className="col-sm-6">*/}
                                    {/*                                    <input*/}
                                    {/*                                    value={formData.companyShortName}*/}
                                    {/*                                    onChange={(e) => handleInputChange(e, "companyShortName")}*/}
                                    {/*                                        type="text"*/}
                                    {/*                                        id="companyShortName"*/}
                                    {/*                                        placeholder="Company Short Name"*/}
                                    {/*                                        className="form-control"*/}

                                    {/*                                    />*/}
                                    {/*                                </div>*/}
                                    {/*                            </div>*/}

                                    {/*                            */}{/* Website */}
                                    {/*                            <div className="row mb-3">*/}
                                    {/*                                <label htmlFor="website" className="col-sm-4 col-form-label">Website</label>*/}
                                    {/*                                <div className="col-sm-6">*/}
                                    {/*                                    <input*/}
                                    {/*                                    value={formData.website}*/}
                                    {/*                                    onChange={(e) => handleInputChange(e, "website")}*/}
                                    {/*                                        type="url"*/}
                                    {/*                                        id="website"*/}
                                    {/*                                        placeholder="Website"*/}
                                    {/*                                        className="form-control"*/}
                                    {/*                                        ref={websiteRef}*/}
                                    {/*                                    />*/}
                                    {/*                                </div>*/}
                                    {/*                            </div>*/}
                                    {/*                            <div style={{ marginTop: '1rem' }}>*/}

                                    {/*                            </div>*/}
                                    {/*                        </form>*/}
                                    {/*                    </TabPanel>*/}
                                    {/*                </Box>*/}
                                    {/*            </div>*/}
                                    {/*        </form>*/}
                                    {/*    </div>*/}


                                    {/*</div>*/}
                                    {/*<div className="col-lg-4">*/}


                                    {/*    <div className="card-body">*/}

                                    {/*        <div>*/}

                                    {/*            <TabPanel value={topTabIndex} index={0}>*/}

                                    {/*            </TabPanel>*/}
                                    {/*            <TabPanel value={topTabIndex} index={1}>*/}
                                    {/*                This tab contains the Customers of the Partner*/}
                                    {/*            </TabPanel>*/}
                                    {/*            <TabPanel value={topTabIndex} index={2}>*/}
                                    {/*                Demo*/}
                                    {/*            </TabPanel>*/}

                                    {/*        </div>*/}
                                    {/*    </div>*/}


                                    {/*</div>*/}


                                    <div className="container my-4">
                                        <h4 className="mb-3">Partner Details</h4>
                                        <form ref={el => formRefs.current[0] = el}>
                                            <div className="row">


                                            {/* Partner Details */}
                                            <div className="col-md-6">
                                                
                                                <div className="row mb-3">
                                                    <div className="col-md-4">
                                                        <strong>Partner Name:</strong>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm w-75"
                                                            name="partnerName"
                                                            ref={partnerNameRef}
                                                            onBlur={(e)=>{
                                                                checkEmptyField(e);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className="col-md-4">
                                                        <strong>Contact Number:</strong>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm w-75"
                                                            name="contactNumber"
                                                            ref={conatactnumberRef}
                                                            onBlur={(e) => { 
                                                                setPhoneNumber(e.target.value); 
                                                                checkPhoneNumber();
                                                                checkEmptyField(e);
                                                                 }}
                                                                 style={{ borderColor:(phoneExists===true || isValid===false)?'red':''}}
                                                        />
                                                        {phoneExists === true && (
                                                            <div className="form-text text-danger">
                                                                {phoneExists === true ? "Phone number already exists" : "Phone number is available"}
                                                            </div>)}
                                                        {isValid !== null && (<div className="form-text text-danger">{isValid === false ? "Invalid phone number. Please check the format." : ""}</div>)}
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className="col-md-4">
                                                        <strong>Email:</strong>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <input
                                                            type="email"
                                                            className="form-control form-control-sm w-75"
                                                            name="email"
                                                            ref={emailRef}
                                                            onBlur={(e)=>{
                                                                checkEmail();
                                                                checkEmptyField(e);
                                                            }}
                                                            style={{
                                                                borderColor: (emailExists === true || emailformat === true) ? 'red' : ''
                                                              }}
                                                        />
                                                        {emailExists === true && (
                                                            <div className="form-text text-danger">
                                                                {emailExists === true ? "Email already exists" : "Email is available"}
                                                            </div>)}
                                                            {emailformat === true && (
                                                                <div className="form-text text-danger">
                                                                    {emailformat === true ? "Invalid Email format" : ""}
                                                                </div>)

                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-4">
                                                            <strong>Contact Person:</strong>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm w-75"
                                                                name="contactPerson"
                                                                ref={contactpersonRef}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-md-4">
                                                            <strong>Partner Class:</strong>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <select className="form-control form-control-sm w-75" name="partnerClass" ref={partnerClassRef}>
                                                                <option value="Premium">Premium</option>
                                                                <option value="Standard">Standard</option>
                                                                <option value="Basic">Basic</option>
                                                            </select>

                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-md-4">
                                                            <strong>Offline Service Available :</strong>
                                                        </div>
                                                        <div className="col-md-8"  >
                                                            <div className="form-check form-switch">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id="flexSwitchCheckDefault"
                                                                    ref={offlineServiceAvailableRef}
                                                                    onChange={handleActive}
                                                                />
                                                                <label className="form-check-label" htmlFor="flexSwitchCheckDefault">

                                                                    {offlineServiceAvailableRef.current?.checked ? 'Active' : 'Not Active'}
                                                                </label>
                                                            </div>
                                                        </div>


                                                        <Dialog open={confirmStatusOpen} onClose={handleStatusDialogClose}>
                                                            <DialogTitle>Confirm Status Change</DialogTitle>
                                                            <DialogContent>
                                                                <DialogContentText>
                                                                    Are you sure you want to {offlineServiceAvailableRef.current?.checked ? 'activate' : 'deactivate'} for this branch?
                                                                </DialogContentText>
                                                            </DialogContent>
                                                            <DialogActions>
                                                                <Button onClick={handleStatusDialogClose} color="secondary">
                                                                    Cancel
                                                                </Button>
                                                                <Button onClick={handleConfirmStatusChange} color="primary" autoFocus>
                                                                    Confirm
                                                                </Button>
                                                            </DialogActions>
                                                        </Dialog>
                                                    </div>

                                                    <div style={{ marginTop: '20px', display: 'flex', alignItems: 'center' }}>
                                                        {/* Attach Icon Aligned to the Left */}
                                                        <label htmlFor="file-input" style={{ marginRight: '10px' }}>
                                                            <IconButton color="primary" component="span" style={{ color: '#02176D', marginLeft: '-16px' }}>
                                                                <AttachFileIcon style={{ fontSize: '20px' }} />
                                                            </IconButton>
                                                        </label>
                                                        <input
                                                            type="file"
                                                            multiple
                                                            style={{ display: 'none' }}
                                                            id="file-input"
                                                            onChange={handlePartnerFileChange}
                                                        />
                                                        {/* Text Next to Icon */}
                                                        <span style={{ fontSize: '13px', fontWeight: 'bold' }}>Attach Partner Photos</span>
                                                    </div>

                                                    {/* List of Attached Files */}
                                                    <List>
                                                        {files.map((file, index) => (
                                                            <ListItem
                                                                key={index}
                                                                secondaryAction={
                                                                    <IconButton edge="end" onClick={() => handleRemoveFile(index)}>
                                                                        <DeleteIcon />
                                                                    </IconButton>
                                                                }
                                                            >
                                                                {/* Styled Attached Files Name */}
                                                                <ListItemText
                                                                    primary={<span style={{ fontWeight: 'bold', color: '#333' }}>{file.name}</span>}
                                                                    secondary={`${(file.size / 1024).toFixed(2)} KB`}
                                                                />
                                                            </ListItem>
                                                        ))}
                                                    </List>


                                                    {formData.activationLink !== "" && <div className="row mb-3">
                                                        <div className="col-md-4">
                                                            <strong>Activation link:</strong>
                                                        </div>
                                                        <div className="col-md-8">

                                                            <div className="input-group">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={partners.activationLink}
                                                                    readOnly
                                                                />
                                                                <button
                                                                    className="btn btn-outline-primary"
                                                                    onClick={handleCopy}
                                                                    type="button"
                                                                >
                                                                    <i className="bi bi-clipboard"></i> {/* Use Bootstrap Icons or replace with ContentCopyIcon */}
                                                                </button>
                                                            </div>

                                                        </div>
                                                    </div>}

                                                </div>
                                                {/* Order and Customer Tabs */}
                                                <div className="col-md-6">
                                                    <ul className="nav nav-tabs" id="partnerDetailsTabs" role="tablist">
                                                        <li className="nav-item" role="presentation">
                                                            <a
                                                                className="nav-link active"
                                                                id="order-tab"
                                                                data-bs-toggle="tab"
                                                                href="#order"
                                                                role="tab"
                                                                aria-controls="order"
                                                                aria-selected="true"
                                                            >
                                                                Order
                                                            </a>
                                                        </li>
                                                        <li className="nav-item" role="presentation">
                                                            <a
                                                                className="nav-link"
                                                                id="customer-tab"
                                                                data-bs-toggle="tab"
                                                                href="#customer"
                                                                role="tab"
                                                                aria-controls="customer"
                                                                aria-selected="false"
                                                            >
                                                                Customer
                                                            </a>
                                                        </li>
                                                    </ul>
                                                    <div className="tab-content mt-3" id="partnerDetailsTabsContent">
                                                        {/* Order Tab */}
                                                        <div
                                                            className="tab-pane fade show active"
                                                            id="order"
                                                            role="tabpanel"
                                                            aria-labelledby="order-tab"
                                                        >
                                                            <p>Order-related details go here.</p>
                                                        </div>
                                                        {/* Customer Tab */}
                                                        <div
                                                            className="tab-pane fade"
                                                            id="customer"
                                                            role="tabpanel"
                                                            aria-labelledby="customer-tab"
                                                        >
                                                            <p>Customer-related details go here.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Bank and Company Tabs */}
                                            <ul className="nav nav-tabs mt-4" id="bottomTabs" role="tablist">
                                                <li className="nav-item" role="presentation">
                                                    <a
                                                        className="nav-link active"
                                                        id="location-info-tab"
                                                        data-bs-toggle="tab"
                                                        href="#location-info"
                                                        role="tab"
                                                        aria-controls="location-info"
                                                        aria-selected="false"
                                                    >
                                                        Location Information
                                                    </a>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <a
                                                        className="nav-link"
                                                        id="company-info-tab"
                                                        data-bs-toggle="tab"
                                                        href="#company-info"
                                                        role="tab"
                                                        aria-controls="company-info"
                                                        aria-selected="true"
                                                    >
                                                        Company Information
                                                    </a>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <a
                                                        className="nav-link"
                                                        id="bank-info-tab"
                                                        data-bs-toggle="tab"
                                                        href="#bank-info"
                                                        role="tab"
                                                        aria-controls="bank-info"
                                                        aria-selected="false"
                                                    >
                                                        Bank Information
                                                    </a>
                                                </li>
                                            </ul>
                                            <div className="tab-content mt-3" id="bottomTabsContent">
                                                {/* Location Information Tab */}
                                                <div
                                                    className="tab-pane fade show active"
                                                    id="location-info"
                                                    role="tabpanel"
                                                    aria-labelledby="location-info-tab"
                                                >
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Street:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="street"
                                                                ref={streetRef}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Building Number:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="buildingNo"
                                                                ref={buildingNoRef}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Neighborhood:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="neighborhood"
                                                                ref={neighborhoodRef}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>City:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="city"
                                                                ref={cityRef}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>State:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="state"
                                                                ref={stateRef}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Zipcode:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="zipcode"
                                                                ref={zipcodeRef}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Country:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            {/*<input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            name="country"
                                                            ref={countryRef}
                                                            onBlur={(e)=>{
                                                             checkEmptyField(e);
                                                            }}
                                                        />*/}
                                                            <select ref={countryRef} name="country"
                                                                className="form-control form-control-sm"
                                                                value={selectedCountry}
                                                                onChange={(e) => setSelectedCountry(e.target.value)}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            >
                                                                <option value=""></option>
                                                                {
                                                                    countriesData.map((country, index) => (<option key={index} value={country.Name}> {country.Name} </option>))
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>

                                                </div>

                                                {/* Company Information Tab */}
                                                <div
                                                    className="tab-pane fade"
                                                    id="company-info"
                                                    role="tabpanel"
                                                    aria-labelledby="company-info-tab"
                                                >
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>CR Number:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="crNumber"
                                                                value={formData.companyRegistration}
                                                                onChange={(e) => handleInputChange(e, "companyRegistration")}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Company Name:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="companyName"
                                                                value={formData.companyNameEnglish}
                                                                onChange={(e) => handleInputChange(e, "companyNameEnglish")}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Company Name (AR):</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="companyNameAR"
                                                                value={formData.companyNameArabic}
                                                                onChange={(e) => handleInputChange(e, "companyNameArabic")}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Short Name:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="companyShortName"
                                                                value={formData.companyShortName}
                                                                onChange={(e) => handleInputChange(e, "companyShortName")}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Website:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="website"
                                                                value={formData.website}
                                                                onChange={(e) => handleInputChange(e, "website")}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>VAT Number:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="vatNumber"
                                                                value={formData.vatNumber}
                                                                onChange={(e) => handleInputChange(e, "vatNumber")}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Bank Information Tab */}
                                                <div
                                                    className="tab-pane fade"
                                                    id="bank-info"
                                                    role="tabpanel"
                                                    aria-labelledby="bank-info-tab"
                                                >
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Bank Name:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            {/*<input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            name="bankName"
                                                            value={formData.bankName}
                                                            onChange={(e) => handleInputChange(e, "bankName")}
                                                            onBlur={(e)=>{
                                                                checkEmptyField(e);
                                                            }}
                                                        />*/}
                                                            <select
                                                                className="form-control form-control-sm"
                                                                name="bankName"
                                                                value={formData.bankName}
                                                                onChange={(e) => { handleInputChange(e, "bankName") }}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            >
                                                                <option value=""></option>
                                                                {
                                                                    BankNames.map((option, index) => (<option key={index} value={option.en_name}>{option.en_name}</option>))
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Account Number:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="accountNumber"
                                                                value={formData.accountNumber}
                                                                onChange={(e) => handleInputChange(e, "accountNumber")}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong></strong>
                                                        </div>
                                                        {/*<div className="col-md-4">*/}
                                                        {/*    <input*/}
                                                        {/*        type="text"*/}
                                                        {/*        className="form-control form-control-sm"*/}
                                                        {/*        name="attachment"*/}
                                                        {/*        value={formData.attachment}*/}
                                                        {/*        onChange={(e) => handleInputChange(e, "attachment")}*/}
                                                        {/*    />*/}
                                                        {/*</div>*/}
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>IBAN:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="iban"
                                                                value={formData.ibanNumber}
                                                                onChange={(e) => handleInputChange(e, "ibanNumber")}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Account Holder Name:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="accountHolderFullName"
                                                                value={formData.accountHolderName}
                                                                onChange={(e) => handleInputChange(e, "accountHolderName")}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Currency:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            {/*<input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            name="currency"
                                                            value={formData.currency}
                                                             onChange={(e) => handleInputChange(e, "currency")}
                                                             onBlur={(e)=>{
                                                                checkEmptyField(e);
                                                            }}
                                                        />*/}
                                                            <select className="form-control form-control-sm"
                                                                name="currency"
                                                                value={formData.currency}
                                                                onChange={(e) => { handleInputChange(e, "currency") }}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}

                                                            >
                                                                <option value=""></option>
                                                                {
                                                                    CommonCurrency.map((option, index) => (<option key={index} value={option.currency}>{option.currency}</option>))

                                                                }
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Document Name</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="documentName"
                                                                value={formData.documentName}
                                                                onChange={(e) => handleInputChange(e, "documentName")}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Attachment</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input className="form-control" type="file" id="formFile" onChange={handleFileChange} onBlur={(e) => {
                                                                checkEmptyField(e);
                                                            }} />
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
            </main>


        </div>
    )
};

export default NewPartnerViews;